import {
    Comments,
    AccountProfile,
} from './components';
import React, { useEffect } from 'react';
import { connect } from "react-redux";
import * as actions_profile from "redux/actions/profileActions";
import * as actions_comment from "redux/actions/commentActions";
import MarketWinLow from 'components/MarketWinLow';
import MiniLoader from 'components/MiniLoader';
import 'assets/css/profile.css';
import 'assets/css/wall.css';

const Profile = (props) => {
    const followerId = props.match.params.follower_id;

    useEffect(() => {
        if (!followerId || !props.user_id) {
            return;
        }
        props.loadItem({
            id: props.user_id,
            follower_id: followerId,
        }, props.token);
        props.loadList({
            id: props.user_id,
            follower_id: followerId,
        }, props.token);
    }, [followerId, props.user_id]);

    if (!props.sessionReady && !props.user_id) {
        return (
            <div className="profile-page profile-loading">
                <MiniLoader />
            </div>
        );
    }

    return (
        <div className="profile-page">
            <div className="profile-row">
                <div className="profile-main">
                    <AccountProfile key={followerId} followerId={followerId} />
                    <h3 className="profile-comments-title">Publicaciones</h3>
                    <Comments followerId={followerId} />
                </div>
                <div className="profile-side">
                    <MarketWinLow />
                </div>
            </div>
        </div>
    );
};

function mapStateToProps(reducer) {
    return {
        user_id: reducer.session.auth.id,
        token: reducer.session.auth.token,
        sessionReady: reducer.session.sessionReady,
    };
}

const mapDispatchToProps = dispatch => ({
    loadItem: (params, token) =>
        dispatch(actions_profile.loadItem({ params, token })),
    loadList: (params, token) =>
        dispatch(actions_comment.loadListProfile({ params, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
